const imgContainer = document.getElementById('img-container');
const sourceImage = document.getElementById('source-image');
const lens = document.getElementById('lens');
const zoomContainer = document.getElementById('zoom-container');
const zoomedImage = document.getElementById('zoomed-image');

const zoomLevel = 2.5;
const lensSizeRatio = 0.4;
let lensWidth = 0;
let lensHeight = 0;
let isImageLoaded = false;

// Initialize
function init() {
	isImageLoaded = true;
	updateMagnifier();
}

// Update magnifier calculations
function updateMagnifier() {
	if (!isImageLoaded) return;

	const sourceImgRect = sourceImage.getBoundingClientRect();
	const aspectRatio = sourceImgRect.height / sourceImgRect.width;

	lensWidth = sourceImgRect.width * lensSizeRatio;
	lensHeight = lensWidth * aspectRatio;

	// Set lens size
	lens.style.width = lensWidth + 'px';
	lens.style.height = lensHeight + 'px';

	// Set zoomed image size
	zoomedImage.style.width = sourceImgRect.width * zoomLevel + 'px';
	zoomedImage.style.height = sourceImgRect.height * zoomLevel + 'px';
}

// Event listeners
imgContainer.addEventListener('mousemove', function (e) {
	if (!isImageLoaded) return;

	// Get cursor position
	const rect = imgContainer.getBoundingClientRect();
	const x = e.clientX - rect.left;
	const y = e.clientY - rect.top;

	// Move lens
	let lensLeft = x - lensWidth / 2;
	let lensTop = y - lensHeight / 2;

	// Constrain lens to image boundaries
	if (lensLeft < 0) lensLeft = 0;
	if (lensTop < 0) lensTop = 0;
	// if (lensLeft > sourceImage.width - lensWidth) lensLeft = sourceImage.width - lensWidth;
	// if (lensTop > sourceImage.height - lensHeight) lensTop = sourceImage.height - lensHeight;

    const sourceImgRect = sourceImage.getBoundingClientRect();
    const imageWidth = sourceImgRect.width;
    const imageHeight = sourceImgRect.height;
    
    if (lensLeft > imageWidth - lensWidth) lensLeft = imageWidth - lensWidth;
    if (lensTop > imageHeight - lensHeight) lensTop = imageHeight - lensHeight;

	// Position lens
	lens.style.left = lensLeft + 'px';
	lens.style.top = lensTop + 'px';

	// Calculate zoomed image position
	const scaleX = zoomedImage.offsetWidth / sourceImgRect.width;
    const scaleY = zoomedImage.offsetHeight / sourceImgRect.height;
    
    const zoomX = lensLeft * scaleX;
    const zoomY = lensTop * scaleY;

	// Position zoomed image
	zoomedImage.style.left = -zoomX + 'px';
	zoomedImage.style.top = -zoomY + 'px';
});

imgContainer.addEventListener('mouseenter', function () {
	if (isImageLoaded) {
		lens.style.display = 'block';
	}
});

imgContainer.addEventListener('mouseleave', function () {
	lens.style.display = 'none';
});

// Initialize the magnifier
init();